import BurnIngicator from '@/components/common/BurnIngicator';

/**
 * 目標コンポーネント ローディング
 * @param param0
 * @returns
 */
export default function FootballlogGoalsEditLoading() {
  return (
    <>
      <div
        className="relative w-full bg-cover bg-center rounded-lg bg-gray-50 shadow"
        style={{ backgroundImage: "url('/images/goals.jpg')" }}>
        <div className="flex h-32 animate-pulse">
          <div className="grow p-4 whitespace-pre-line break-all">
            <div className="h-4 bg-green-700/20 rounded-full w-3/4 mb-2"></div>
            <div className="h-4 bg-green-700/20 rounded-full w-1/2 mb-6"></div>
            <div className="h-4 bg-green-700/20 rounded-full w-3/4 mb-2"></div>
            <div className="h-4 bg-green-700/20 rounded-full w-1/4 mb-2"></div>
          </div>
          <div className="absolute top-2 right-2 flex items-center justify-center w-6 h-6 rounded-full bg-gray-300"></div>
        </div>
        <div className="mt-1 p-4">
          <BurnIngicator stage={0} />
        </div>
      </div>
    </>
  );
}
